/**
* Team Grid JS
* -----------------------------------------------------------------------------
*
* All the JS for the Team Grid component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import ScrollMagic from 'ScrollMagic';
// import animationGSAP from 'animation.gsap';
// import addIndicators from 'debug.addIndicators';
// import TweenMax from 'TweenMax';
// import TimelineMax from 'TimelineMax';
( function( app ) {
  const COMPONENT = {

    className: 'team-grid',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      $( '.member-popup-link' ).magnificPopup( {
        type: 'inline',
        preloader: false,
      } );

      $( document ).on( 'click', '.popup-modal-dismiss', function( e ) {
        e.preventDefault();
        $.magnificPopup.close();
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'team-grid', COMPONENT );
} )( app );
